import(/* webpackMode: "eager" */ "/app/src/app/(landing)/about/page.tsx");
